import { Component } from 'react';

import BpkGridToggle from '@skyscanner/backpack-web/bpk-component-grid-toggle';
import BpkRtlToggle from '@skyscanner/backpack-web/bpk-component-rtl-toggle';
import BpkSectionHeader from '@skyscanner/backpack-web/bpk-component-section-header';

import withErrorBoundary from '../../ErrorBoundary';
import BrowseList from '../BrowseList';
import { DEFAULT_STRINGS } from '../constants';
import StringsContext from '../contexts/StringsContext';

import type { DestinationsExplorerProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './DestinationsExplorer.module.scss';

class DestinationsExplorer extends Component<DestinationsExplorerProps> {
  componentDidMount() {
    if (window.performance && window.performance.mark) {
      window.performance.mark('destinations-explorer_ready');
    }
  }

  render() {
    const {
      debug = false,
      destination,
      destinations,
      enableLazyLoading = true,
      numberOfDestinations,
      origin,
      shouldNotRedirectToExplore,
      strings = DEFAULT_STRINGS,
      subTitle,
      title,
    } = this.props;
    return (
      destinations.length > 0 && (
        <div id="destinations-explorer" className={STYLES.DestinationsExplorer}>
          {debug && (
            <div className={STYLES.DestinationsExplorer__toggles}>
              <BpkGridToggle /> | <BpkRtlToggle />
            </div>
          )}
          <div>
            {title && (
              <div className={STYLES.DestinationsExplorer__header}>
                <BpkSectionHeader title={title} description={subTitle} />
              </div>
            )}
            <StringsContext.Provider value={strings}>
              <BrowseList
                destinations={destinations}
                enableLazyLoading={enableLazyLoading}
                shouldNotRedirectToExplore={shouldNotRedirectToExplore}
                numberOfDestinations={numberOfDestinations}
                query={{ origin, destination }}
              />
            </StringsContext.Provider>
          </div>
        </div>
      )
    );
  }
}

const DestinationsExplorertWithErrorBoundary = withErrorBoundary(
  DestinationsExplorer,
  'destinations-explorer-component',
);

export default DestinationsExplorertWithErrorBoundary;
